// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2244":"3036db8e","4092":"3036db8e","4342":"3036db8e","5394":"3036db8e"}[chunkId] + ".chunk.css";
};